import { styled } from "styled-components";
import { fSize } from "../../globalStyles";

export const Wrapper = styled.div `

`

export const PostNotFound = styled.div `
  font-size: ${fSize.textLarger};
  padding-bottom: 2rem;

  display: flex;
  align-items: flex-start;
  flex-direction: column;
  gap: 1rem;
`